import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { OnValueChange } from 'types/global';

type BooleanTipsSettingsProps = OnValueChange<boolean>;

export const BooleanTipsSettings = ({ value, onChange }: BooleanTipsSettingsProps) => (
  <BooleanSettings titleText="Подсказка" value={value} onChange={onChange} />
);
